<template>
  <div class="footComponent-container">
    <div class="topBox">
      <div class="leftBox">
        <div class="title">产品介绍</div>
        <div class="content" @click="handleJump(4)">"全域"低空感知精细化运营解决方案</div>
        <div class="leftBottom">
          <!-- <div class="content" @click="handleJump(3)">PMPP 混合现实实训平台</div>
          <div class="content" @click="handleJump(2)">PMPE ME-MODEL Alpha 边缘实训单元套装</div> -->
          <!-- "全域"低空感知精细化运营解决方案 -->
          <div class="content" @click="handleJump(2)">行业领域</div>
        </div>
      </div>
      <div class="rightBox">
        <div class="title">联系我们</div>
        <div class="rightBottom">
          <div  class="content">地 址：上海市杨浦区黄兴路2005弄杨浦科技 大厦2号楼702室</div>
          <div  class="content">联系方式：021-65102886</div>
          <!-- <div class="content" @click="handleJump(7)">公司介绍</div>
          <div class="content" @click="handleJump(8)">联系我们</div>
          <div class="content" @click="handleJump(9)">公司动态</div> -->
        </div>
      </div>
    </div>
    <div class="QRcode">
      <div class="QRtitle">微信公众号</div>
      <div class="QRcodeImg">
        <img src="../assets/pageImg/135931701157217_.pic.jpg" alt="">
      </div>
    </div>
    <div class="bottomBox">
       MOBSAVATAR 上海元魔凡信息技术有限公司保留所有权力 | <a class="linkbox" href="https://beian.miit.gov.cn">沪ICP备2022013721号</a>
      <div style="width:300px;margin:0 auto; padding:20px 0;">
     <a target="_blank" href="https://www.beian.gov.cn/portal/recordQuery?token=e73bdec2-98de-4798-9f6b-9c242c16b7e5" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../assets/pageImg/batb.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31011002005912号</p ></a >
    </div>
    </div>
  </div>
</template>

<script>
import Bus from "../bus.js";
export default {
  name: "footComponent",
  data() {
    return {};
  },
  methods: {
    handleJump(e) {
      if (e === 2 || e === 3 || e === 4) {
        // console.log(this.$refs.pmpe)
        // document.documentElement.scrollTop =this.$refs.pmpe.getBoundingClientRect().top
        if (this.$route.path == "/" || this.$route.path == undefined) {
          Bus.$emit("jump", e);
          Bus.$emit('changeNav',e);
        } else {
          this.$router.push({
            path: "/",
            query: {
              jump: e,
            },
          });
          // Bus.$emit("jump", e);
          Bus.$emit('changeNav',e);
        }
      }

      if (e === 7 || e === 8) {
        if (this.$route.path == "/about") {
          Bus.$emit("jump", e);
        } else {
          this.$router.push({
            path: "/about",
            query: {
              jump: e,
            },
          });
          // Bus.$emit("jump", e);
          Bus.$emit('changeNav',e);
        }
      }
      if (e === 9) {
        if (this.$route.path == "/news") {
          Bus.$emit("jump", e);
        } else {
          this.$router.push({
            path: "/news",
            query: {
              jump: e,
            },
          });
          // Bus.$emit("jump", e);
          Bus.$emit('changeNav',e);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.linkbox{
  color: #9d9ea9;
}
.title {
  font-weight: 500;
  margin-bottom: 10px;
}
.content {
  color: #9d9ea9;
}
.footComponent-container {
  padding-top: 20px;
  padding-bottom: 10px;
  color: #fff;
  height:300px;
  position: relative;
  .topBox {
    display: flex;
    flex-flow: row nowrap;
    .leftBox {
      width: 49%;
      .leftBottom {
        width: 90%;
        margin-top: 10px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
      }
    }
    .rightBox {
      width: 49%;
      .rightBottom {
        width: 50%;
        margin-top: 10px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        div{
          margin-bottom:10px;
        }
      }
    }
  }

  .QRcode{
    display: flex;
    flex-flow: column nowrap;
    position: absolute;
    right:0px;
    top:20px;
    .QRtitle{
      margin-bottom:10px;
    }
    .QRcodeImg{
      width:200px;
      height:200px;
      background-color: white;
      img{
        height:100%;
        width:100%;
      }
    }
  }

  .bottomBox {
    position: absolute;
    bottom:10px;
    left:50%;
    transform: translateX(-50%);
    margin-top: 20px;
    text-align: center;
    color: #9d9ea9;
    // margin-bottom:20px;
  }
}
@media screen and (max-width: 767px) {
  .footComponent-container {
    height:500px;
    .topBox {
      .leftBox{
        .leftBottom{
          .content{
            width:46%;
          }
        }
      }
      
      .rightBox {
        .rightBottom {
          width: 100%;
        }
      }
    }
    .QRcode{
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
      }
  }
}
</style>